import React, { useCallback, useEffect, useState } from "react";
import { Container } from "./style";
import { useApi } from "../../../hooks/api";
import { ModalHeader } from "../../ModalHeader";
import { useGlobal } from "../../../hooks/global";
import { ModalGeneric } from "../../ModalGeneric";
import { ContentOrLoading } from "../../Loadings/ContentOrLoading";
import { FormSendWppMessage } from "./form";

interface IModalSendWppProps {
    onCancel: Function;
    onSave: Function;
    openModal: boolean;
    backgroundVisible?: boolean;
    id: string;
}

const texts: any = {
    title: "Envio de mensagem via WhatsApp",
    subTitle: "Informe os dados da mensagem",
};

export const ModalSendWpp: React.FC<IModalSendWppProps> = (props) => {
    const { onCancel, onSave, openModal, backgroundVisible, id } = props;
    const [messageModelsOptions, setMessageModelsOptions] = useState<any[]>([]);
    const [variables, setVariables] = useState<any>({});

    const { api } = useApi();
    const { theme, notify } = useGlobal();

    const [loading, setLoading] = useState(true);

    const handleSearchMessageModels = useCallback(async () => {
        setLoading(true);
        try {
            const [{ data }, { data: data2 }] = await Promise.all([
                api.get(`/message-models?type=wpp&limit=100&page=1`),
                api.get(`/variables-wpp/${id}`)
            ]);
            setMessageModelsOptions(data.data.map((item: any) => ({ value: item.id, label: item.name, this: item })));
            setVariables(data2);
        } catch (err) {
            notify("Erro ao buscar os modelos de mensagem", "error");
            onCancel();
        }
        setLoading(false);
    }, []);

    useEffect(() => {
        handleSearchMessageModels();
    }, []);

    return (
        <ModalGeneric
            backgroundVisible={backgroundVisible}
            open={openModal}
            onClose={() => { }}
        >
            <Container theme={theme}>
                <ModalHeader
                    title={texts.title}
                    subTitle={texts.subTitle}
                    onCancel={() => onCancel()}
                    theme={theme}
                />
                <ContentOrLoading type="wave" loading={loading} theme={theme}>
                    {!loading && (
                        <FormSendWppMessage
                            onSave={onSave}
                            onCancel={onCancel}
                            options={messageModelsOptions}
                            phones={variables.phones}
                            variables={variables}
                        />
                    )}
                </ContentOrLoading>
            </Container>
        </ModalGeneric>
    );
};
